import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";

interface UsersChartProps {
  data: { name: string; value: number; color: string }[];
}

const UsersChart: React.FC<UsersChartProps> = ({ data }) => {
  return (
    <div className="chart-container">
      <div className="chart-header">
        <div>
          <h3>Users</h3>
          <p>Active vs. Inactive Users</p>
        </div>

        <div>
          <div className="total-count">
            <p>Total Users</p>
            <h2>{data.reduce((acc, curr) => acc + curr.value, 0).toLocaleString()}</h2>
          </div>
        </div>
        
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            paddingAngle={0}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="chart-legend">
        {data.map((entry, index) => (
          <div key={index} className="legend-item">
            <span
              className="legend-dot"
              style={{ backgroundColor: entry.color }}
            ></span>
            <span className="legend-label">{entry.name}</span>
            <span className="legend-value">{entry.value}</span>
          </div>
        ))}
      </div>
      
    </div>
  );
};

export default UsersChart;
